import { enLang } from './entries/en-US';
import { esLang } from './entries/es-ES';
import { ptLang } from './entries/pt-BR';

export const AppLocale = {
  'pt-br': ptLang,
  en: enLang,
  es: esLang,
};



// WEBPACK FOOTER //
// ./src/lang/index.js